import React from "react";
import * as Highcharts from "highcharts";
import Icon from "@ant-design/icons";
import {Tooltip} from "antd";
import helpImg from "../../imagers/icon/help.png";

interface CardData{
    param:any;
}
const RailHighchartsColumn: React.FC<CardData> = (cardData) => {
    React.useEffect(() => {
        let seriesData = new Array({name:"运行效率 %",data:new Array()},{name:"故障停车时间 H",data:new Array()},{name:"平均无故障时间 H",data:new Array()}),
            categories = new Array(),craneDataList = cardData.param.data?.craneDataList??[];
        if(craneDataList.length > 0){
            for(let i=0;i<craneDataList.length;i++) {
                const crane = craneDataList[i];
                categories.push(crane.craneName);
                seriesData[0].data.push(Number(crane.operatingData?.operatingEff??0));
                seriesData[1].data.push(Number(crane.operatingData?.faultTime??0));
                seriesData[2].data.push(Number(crane.operatingData?.faultFreeTimeAvg??0));
            }

        }
        (Highcharts as any).chart(document.getElementById(cardData.param.id+'PreviewColumn'), {
            credits:{enabled:false},
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'column',
                backgroundColor:"#e6e6e6"
            },
            title: {
                useHTML:true,
                text: ''
            },
            xAxis: {
                categories: categories,
                crosshair: true,
                accessibility: {
                    description: 'Countries'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                }
            },
            tooltip: {

            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: seriesData
        });
    },[]);
    return (
        <div style={{display:"flex",flexFlow: "column",height:"100%"}}>
            <div style={{backgroundColor:"#e6e6e6",textAlign:"center",fontSize:"18px",lineHeight:"30px"}}>
                统计
                <Tooltip color="#C9CACA"
                         overlayInnerStyle={{color:"var(--contentColor)",marginTop:"-8px"}}
                         placement="bottom"
                         title={"运行效率、故障停车时间、平均无故障时间均为前一周的统计数据。"}>
                    <Icon component={() => (<img src={helpImg} style={{width:"24px",height:"24px",marginBottom:"7px"}}/>)}/>
                </Tooltip>
            </div>
            <div id={cardData.param.id+'PreviewColumn'} style={{flex:"1",background:"#e6e6e6"}}></div>
        </div>
    );
}
export default RailHighchartsColumn;